import { Component, Input } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import {
  CardModule,
  CheckboxModule,
  DropdownModule,
  RadioButtonModule,
  AlertModule,
  TooltipModule,
} from 'axis-components';
import { CommonModule} from '@angular/common';
import { BaseRules, TextValues } from './oregon.model';
import { PipBaseStateComponent } from '../pip-base-state.component';
import { TruncateModule } from 'axis-components/truncate';

@Component({
  selector: 'app-oregon',
  templateUrl: './oregon.component.html',
  styleUrls: ['./oregon.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    CardModule,
    CheckboxModule,
    DropdownModule,
    ReactiveFormsModule,
    RadioButtonModule,
    AlertModule,
    TruncateModule,
    TooltipModule
  ]
})
export class OregonComponent extends PipBaseStateComponent<BaseRules, TextValues> {
  @Input() set formGroup(form: FormGroup | null) {
    if (form) {
      super.getJsonRuleFiles('oregon', form);
    }
  }
  @Input() set isReview(review: boolean) {
    if (review) {
      super.getJsonRuleFiles('oregon', null);
    }
  }
  
}
